import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';

import IconButton from 'components/common/IconButton';
import IconDelivery from 'components/icons/IconDelivery';
import DeliveryDialog from 'components/workflow/DeliveryDialog';

const styles = theme => ({
  button: {
    width: 36,
    height: 36,
  },
  buttonSelected: {
    color: theme.palette.primary[500],
  },
  iconClipRotated: {
    width: 24,
    height: 24,
    margin: -4,
  },
});

class ProductClaimDeliveryFields extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
  }

  onButtonClick() {
    const { onFieldFocus, name, nameKeys, ...fields } = this.props;
    const driverID = get(fields, `${name}.${nameKeys.driverID}`);
    const driverName = get(fields, `${name}.${nameKeys.driverName}`);
    const selectedDriverName = get(fields, `${name}.${nameKeys.selectedDriverName}`);
    const placeOfSRV = get(fields, `${name}.${nameKeys.placeOfSRV}`);
    const dateOfDelivery = get(fields, `${name}.${nameKeys.dateOfDelivery}`);
    const timeOfDelivery = get(fields, `${name}.${nameKeys.timeOfDelivery}`);
    onFieldFocus({
      [nameKeys.driverID]: driverID.input.value,
      [nameKeys.driverName]: driverName.input.value,
      [nameKeys.selectedDriverName]: selectedDriverName.input.value,
      [nameKeys.placeOfSRV]: placeOfSRV.input.value,
      [nameKeys.dateOfDelivery]: dateOfDelivery.input.value,
      [nameKeys.timeOfDelivery]: timeOfDelivery.input.value,
    });
    this.setState({ dialogOpen: true });
  }

  onDialogClose() {
    const { onFieldBlur, name, nameKeys, ...fields } = this.props;
    const driverID = get(fields, `${name}.${nameKeys.driverID}`);
    const driverName = get(fields, `${name}.${nameKeys.driverName}`);
    const selectedDriverName = get(fields, `${name}.${nameKeys.selectedDriverName}`);
    const placeOfSRV = get(fields, `${name}.${nameKeys.placeOfSRV}`);
    const dateOfDelivery = get(fields, `${name}.${nameKeys.dateOfDelivery}`);
    const timeOfDelivery = get(fields, `${name}.${nameKeys.timeOfDelivery}`);

    onFieldBlur({
      [nameKeys.driverID]: driverID.input.value,
      [nameKeys.driverName]: driverName.input.value,
      [nameKeys.selectedDriverName]: selectedDriverName.input.value,
      [nameKeys.placeOfSRV]: placeOfSRV.input.value,
      [nameKeys.dateOfDelivery]: dateOfDelivery.input.value,
      [nameKeys.timeOfDelivery]: timeOfDelivery.input.value,
    });
    this.setState({ dialogOpen: false });
  }

  render() {
    const { name, classes, formValues, onFieldBlur, disabled, className, nameKeys, variant, ...fields } = this.props;
    const driverID = get(fields, `${name}.${nameKeys.driverID}`);
    const driverName = get(fields, `${name}.${nameKeys.driverName}`);
    const selectedDriverName = get(fields, `${name}.${nameKeys.selectedDriverName}`);
    const placeOfSRV = get(fields, `${name}.${nameKeys.placeOfSRV}`);
    const dateOfDelivery = get(fields, `${name}.${nameKeys.dateOfDelivery}`);
    const timeOfDelivery = get(fields, `${name}.${nameKeys.timeOfDelivery}`);
    const { dialogOpen } = this.state;
    let tooltipContent = [];
    if (driverID && driverID.input.value) {
      tooltipContent = [
        ...tooltipContent,
        `Driver: ${driverName.input.value}`,
      ];
    }
    if (placeOfSRV && placeOfSRV.input.value) {
      tooltipContent = [
        ...tooltipContent,
        `Place of Service: ${placeOfSRV.input.value}`,
      ];
    }
    if (dateOfDelivery && dateOfDelivery.input.value) {
      tooltipContent = [
        ...tooltipContent,
        `Date of Delivery: ${dateOfDelivery.input.value}`,
      ];
    }
    if (timeOfDelivery && timeOfDelivery.input.value) {
      tooltipContent = [
        ...tooltipContent,
        `Time of Delivery: ${timeOfDelivery.input.value}`,
      ];
    }
    return (
      <Fragment>
        <IconButton
          className={classNames(classes.button, className, {
            [classes.buttonSelected]: driverID.input.value || dateOfDelivery.input.value || timeOfDelivery.input.value,
          })}
          onClick={this.onButtonClick}
          tooltipContent={tooltipContent.length ? tooltipContent.join('; ') : 'Delivery Information'}
          disabled={disabled}
        >
          <IconDelivery className={classes.iconClipRotated} />
        </IconButton>
        <DeliveryDialog
          open={dialogOpen}
          onClose={this.onDialogClose}
          form={`${name}-Delivery`}
          formValues={formValues}
          variant={variant}
          initialValues={{
            driverID: driverID.input.value,
            driverName: driverName.input.value,
            selectedDriverName: selectedDriverName.input.value,
            placeOfSRV: placeOfSRV.input.value,
            dateOfDelivery: dateOfDelivery.input.value,
            timeOfDelivery: timeOfDelivery.input.value,
          }}
          onSubmitSuccess={(values) => {
            driverID.input.onChange(values.driverID);
            driverName.input.onChange(values.driverName);
            selectedDriverName.input.onChange(values.selectedDriverName);
            placeOfSRV.input.onChange(values.placeOfSRV);
            dateOfDelivery.input.onChange(values.dateOfDelivery);
            timeOfDelivery.input.onChange(values.timeOfDelivery);
            onFieldBlur({
              [nameKeys.driverID]: values.driverID,
              [nameKeys.driverName]: values.driverName,
              [nameKeys.selectedDriverName]: values.selectedDriverName,
              [nameKeys.placeOfSRV]: values.placeOfSRV,
              [nameKeys.dateOfDelivery]: values.dateOfDelivery,
              [nameKeys.timeOfDelivery]: values.timeOfDelivery,
            });
            this.setState({ dialogOpen: false });
          }}
        />
      </Fragment>
    );
  }
}

ProductClaimDeliveryFields.propTypes = {
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'no-driver']),
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    buttonSelected: PropTypes.string.isRequired,
    iconClipRotated: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimDeliveryFields.defaultProps = {
  formValues: {},
  onFieldFocus: () => {},
  onFieldBlur: () => {},
  disabled: false,
  className: '',
  variant: 'default',
};

export default withStyles(styles)(ProductClaimDeliveryFields);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimDeliveryFields.js